module.exports = __webpack_public_path__ + "static/media/ok.b4023e77.svg";